import { render, staticRenderFns } from "./proposal.vue?vue&type=template&id=29ea9757&scoped=true&lang=pug"
import script from "./proposal.vue?vue&type=script&lang=js"
export * from "./proposal.vue?vue&type=script&lang=js"
import style0 from "./proposal.vue?vue&type=style&index=0&id=29ea9757&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ea9757",
  null
  
)

export default component.exports